export const getCommonEnvVariables = () => {
    const { VITE_PUBLIC_HASURA_URL, VITE_PUBLIC_LMS_SERVICE_URL, MODE } =
        import.meta.env;
    return {
        VITE_PUBLIC_HASURA_URL,
        VITE_PUBLIC_LMS_SERVICE_URL,
        MODE,
    };
};
